import { render, staticRenderFns } from "./locadorPrestador.vue?vue&type=template&id=5fbaa7af&scoped=true"
import script from "./locadorPrestador.vue?vue&type=script&lang=js"
export * from "./locadorPrestador.vue?vue&type=script&lang=js"
import style0 from "./locadorPrestador.vue?vue&type=style&index=0&id=5fbaa7af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbaa7af",
  null
  
)

export default component.exports